import { render, staticRenderFns } from "./DevTaskTrend.vue?vue&type=template&id=6d51cfbe&scoped=true"
import script from "./DevTaskTrend.vue?vue&type=script&lang=js"
export * from "./DevTaskTrend.vue?vue&type=script&lang=js"
import style0 from "./DevTaskTrend.vue?vue&type=style&index=0&id=6d51cfbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d51cfbe",
  null
  
)

export default component.exports